export enum FirestoreCollectionEnum {
  chat = 'chat',
  messages = 'messages',
  notifications = 'notifications',
  chatNotificationDevices = 'chat-notification-devices'
}
